import React from 'react';
import TaxCertificate from '../components/TaxCertificate';


export default function TaxCertificates() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
      <main>
        <TaxCertificate />
      </main>
      
    </div>
  );
}